// // Footer.js
// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPhone,
//   faMapMarkerAlt,
//   faEnvelope,
// } from "@fortawesome/free-solid-svg-icons";
// import {
//   faFacebookF,
//   faInstagram,
//   faLinkedinIn,
// } from "@fortawesome/free-brands-svg-icons";
// import "./Footer.css";

// // ✅ import your logo (place it inside /src/assets or /src/images)
// import logo from "../images/jusstmingle-logo.png";

// const Footer = () => {
//   const year = new Date().getFullYear();

//   // — centralised contact values —
//   const address =
//     "Office no. 213-214,Second Floor, City Point, Boat Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra 411001";
//   const phone = "+91 7276445893";
//   const email = "info@aaziratechnologies.com";

//   const mapsDirHref = `https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${encodeURIComponent(
//     address
//   )}&travelmode=driving`;

//   const telHref = `tel:${phone.replace(/\s+/g, "")}`;
//   const mailHref = `mailto:${email}`;

//   return (
//     <footer className="footer-section" role="contentinfo">
//       <div className="footer-bg" aria-hidden="true" />

//       {/* CTA strip */}
//       <div className="footer-cta">
//         <Container>
//           <div className="cta-inner">
//             <span className="cta-text">
//               Have a project in mind? Let’s build something great together.
//             </span>
//             <Link
//               className="cta-btn"
//               to="/contact"
//               aria-label="Start a conversation"
//             >
//               Start a Conversation
//             </Link>
//           </div>
//         </Container>
//       </div>

//       <Container>
//         <Row className="footer-top">
//           <Col lg={3} md={6} sm={12} className="footer-info mb-4">
//             {/* ✅ Added logo */}
//             <Link to="/" className="footer-logo" aria-label="Aazira Solutions home">
//               <img src={logo} alt="Aazira Solutions Logo" className="footer-logo-img" />
//             </Link>

//             <p>
//               We engineer secure, scalable software that powers real business
//               outcomes. Build with confidence—design, delivery and support under
//               one roof.
//             </p>

//             {/* ✅ Added extra paragraph */}
//             {/* <p className="child-company">
//               Aazira Solutions Pvt. Ltd. is a brand of DATTA COMPANY Pvt. Ltd.(Registered office:712,Shukrawar Peth,Pune 411002,India)
//             </p> */}
//             {/* ✅ Company + brand note (semantically improved) */}

//           </Col>

//           <Col lg={3} md={6} sm={12} className="footer-links mb-4">
//             <h4>Quick Links</h4>
//             <ul>
//               <li><Link to="/">Home</Link></li>
//               <li><Link to="/products">Products</Link></li>
//               <li><Link to="/services">Services</Link></li>
//               <li><Link to="/about">About Us</Link></li>
//               <li><Link to="/contact">Contact</Link></li>
//             </ul>
//           </Col>

//           <Col lg={3} md={6} sm={12} className="footer-services mb-4">
//             <p className="child-company" role="note">
//   <span className="child-company__label">Aazira Solutions Pvt. Ltd.</span>
//   <span className="child-company__sep"> is a brand of </span>
//   <span className="child-company__owner">DATTA COMPANY Pvt. Ltd.</span>
//   <span className="child-company__addr">
//     (Registered office: 712, Shukrawar Peth, Pune 411002, India)
//   </span>
// </p>


//             <div className="social-links" aria-label="Social media">
//               <a
//                 href="https://facebook.com"
//                 target="_blank"
//                 rel="noreferrer"
//                 title="Facebook"
//               >
//                 <FontAwesomeIcon icon={faFacebookF} />
//               </a>
//               <a
//                 href="https://instagram.com"
//                 target="_blank"
//                 rel="noreferrer"
//                 title="Instagram"
//               >
//                 <FontAwesomeIcon icon={faInstagram} />
//               </a>
//               <a
//                 href="https://linkedin.com"
//                 target="_blank"
//                 rel="noreferrer"
//                 title="LinkedIn"
//               >
//                 <FontAwesomeIcon icon={faLinkedinIn} />
//               </a>
//             </div>
//           </Col>

//           <Col lg={3} md={6} sm={12} className="footer-contact mb-4">
//             <h4>Contact Us</h4>
//             <ul>
//               <li>
//                 <FontAwesomeIcon icon={faMapMarkerAlt} />
//                 <a
//                   href={mapsDirHref}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="contact-link"
//                   title="Get Directions"
//                 >
//                   {address}
//                 </a>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faPhone} />
//                 <a href={telHref} className="contact-link">
//                   {phone}
//                 </a>
//               </li>
//               <li>
//                 <FontAwesomeIcon icon={faEnvelope} />
//                 <a href={mailHref} className="contact-link">
//                   {email}
//                 </a>
//               </li>
//             </ul>
//           </Col>
//         </Row>

//         <Row className="footer-bottom">
//           <Col>
//             <p className="copyright">
//               © {year} Aazira Solutions Pvt. Ltd. All rights reserved.
//             </p>
//             <p className="made-in">
//               Made with <span aria-hidden="true">♥</span> in Pune
//             </p>
//           </Col>
//         </Row>
//       </Container>
//     </footer>
//   );
// };

// export default Footer;




// Footer.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMapMarkerAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  // faFacebookF,
  faInstagram,
  // faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

// ✅ logo
import logo from "../images/jusstmingle-logo.png";

const Footer = () => {
  const year = new Date().getFullYear();

  // centralised contact values
  const address =
    "Office no. 213-214,Second Floor, City Point, Boat Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra 411001";
  const phone = "+91 7276445893";
  const email = "info@aaziratechnologies.com";

  const mapsDirHref = `https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${encodeURIComponent(
    address
  )}&travelmode=driving`;

  const telHref = `tel:${phone.replace(/\s+/g, "")}`;
  const mailHref = `mailto:${email}`;

  return (
    <footer className="footer-section" role="contentinfo">
      <div className="footer-bg" aria-hidden="true" />

      {/* CTA strip */}
      <div className="footer-cta">
        <Container>
          <div className="cta-inner">
            <span className="cta-text">
              Have a project in mind? Let’s build something great together.
            </span>
            <Link className="cta-btn" to="/contact" aria-label="Start a conversation">
              Start a Conversation
            </Link>
          </div>
        </Container>
      </div>

      <Container>
        <Row className="footer-top">
          <Col lg={3} md={6} sm={12} className="footer-info mb-4">
            {/* <Link to="/" className="footer-logo" aria-label="Aazira Solutions home">
              <img src={logo} alt="Aazira Solutions Logo" className="footer-logo-img" />
            </Link> */}
            <Link to="/" className="footer-logo" aria-label="Aazira Solutions home">
  <img
    src={logo}
    alt="Aazira Solutions Logo"
    className="footer-logo-img logo-animate"   // 👈 add this
  />
</Link>


            <p>
              We craft modern, cloud-ready software that helps your business move faster. One team for strategy, design, development, testing, and maintenance.
            </p>

          </Col>

          <Col lg={3} md={6} sm={12} className="footer-links mb-4">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>

          <Col lg={3} md={6} sm={12} className="footer-services mb-4">
            <h4>Follow Us</h4>
            <div className="social-links" aria-label="Social media">
              {/* <a href="https://facebook.com" target="_blank" rel="noreferrer" title="Facebook">
                <FontAwesomeIcon icon={faFacebookF} />
              </a> */}
              <a href="https://www.instagram.com/aazirasolutions/" target="_blank" rel="noreferrer" title="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              {/* <a href="https://linkedin.com" target="_blank" rel="noreferrer" title="LinkedIn">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a> */}
            </div>
            <p className="" role="note">
              <span className="child-company__label">Aazira Solutions Pvt. Ltd.</span>
              <span className="child-company__sep"> is a brand of </span>
              <span className="child-company__owner">DATTA COMPANY Pvt. Ltd.</span>
              <span className="child-company__addr">
                {" "}
                (Registered office: 712, Shukrawar Peth, Pune 411002, India)
              </span>
            </p>
          </Col>

          <Col lg={3} md={6} sm={12} className="footer-contact mb-4">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                <a
                  href={mapsDirHref}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-link"
                  title="Get Directions"
                >
                  {address}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} />
                <a href={telHref} className="contact-link">{phone}</a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} />
                <a href={mailHref} className="contact-link">{email}</a>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="footer-bottom">
          <Col>
            <p className="copyright">
              © {year} Aazira Solutions Pvt. Ltd. All rights reserved.
            </p>
            <p className="made-in">
              Made with <span aria-hidden="true">♥</span> in Pune
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
